import React from "react";
import "./ProductList.scss";

const travelitems = [
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B000LAKYW8&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Casio Men's Vintage A168WA-1 Electro Luminescence Watch",
    alt: "casio watch",
    url: "https://amzn.to/3yhOghR",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B00B8I3MLC&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Casio Vintage Collection Digital Unisex Bracelet Watch (Gold)",
    alt: "gold male casio",
    url: "https://amzn.to/3tW1pto",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B08GTYFC37&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "SanDisk 1TB Extreme Portable SSD - Up to 1050MB/s - USB-C, USB 3.2 Gen 2 - External Solid State Drive - SDSSDE61-1T00-G25",
    alt: "external hdd",
    url: "https://amzn.to/3otsjI8",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B08P5LRY37&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Power Strip , Alestor Surge Protector with 12 Outlets and 4 USB Ports, 6 Feet Extension Cord (1875W/15A) for for Home, Office, Dorm Essentials, 2700 Joules, ETL Listed, - Black",
    alt: "Power strip",
    url: "https://amzn.to/2RW9n8z",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B07KS7MHRD&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Uniclife 5 Pack Mini Keychain Flashlight Ultra Bright LED Key Ring Light Torch, Black",
    alt: "Flashlight",
    url: "https://amzn.to/3flhaVE",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B00VTVAR2U&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Fruit of the Loom Men's Stay Tucked Crew T-Shirt - Small - White (Pack of 6)",
    alt: "White t-shirt",
    url: "https://amzn.to/3hIeG6D",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B07RL5L8ZL&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "USB C Hub Multiport Adapter - 7 in 1 Portable Space Aluminum Dongle with 4K HDMI Output, 3 USB 3.0 Ports, SD/Micro SD Card Reader Compatible for MacBook Pro, XPS More Type C Devices",
    alt: "White t-shirt",
    url: "https://amzn.to/3yhRG4b",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B004MWVOMA&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Casio Women's Digital Watch with Stainless Steel Bracelet LA670W",
    alt: "Casio Womens Silver",
    url: "https://amzn.to/3bxxJfN",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B078S3M2NX&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "EPICKA Universal Travel Adapter One International Wall Charger AC Plug Adaptor with 5.6A Smart Power and and 3.0A USB Type-C for USA EU UK AUS",
    alt: "Travel Adapter",
    url: "https://amzn.to/3v4Z4xu",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B07MG8NX9W&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Travelon: Family Passport Wallet - Black",
    alt: "Travel documents pouch",
    url: "https://amzn.to/3oqgsub",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B083GCMZHK&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Hydro Flask Water Bottle - Stainless Steel & Vacuum Insulated - Wide Mouth 2.0 with Leak Proof Flex Cap - 32 oz, Spearmint",
    alt: "Water Bottle",
    url: "https://amzn.to/3wnSbrJ",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B07W4HSS33&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Hanging Travel Toiletry Bag,Large Capacity Cosmetic Travel Toiletry Organizer for Women with 4 Compartments & 1 Sturdy Hook,Perfect for Travel/ Daily Use/ Valentines' Day",
    alt: "Womens Toiletry Bag",
    url: "https://amzn.to/3hwejvt",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B01N1G297F&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Herschel Chapter Toiletry Kit, Black, Carry-On 3L",
    alt: "Herschel Toiletry Kit",
    url: "https://amzn.to/3tSqIwn",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B0937JGJ8X&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Vitog Travel Bottles Kit, TSA Approved Leak Proof Portable Toiletry Containers Set, Clear flight size PET Cosmetic Containers for Lotion, Shampoo, Cream, Soap, Set of 11 (Black+Plastic)",
    alt: "Travel Bottles Kit",
    url: "https://amzn.to/3bvm15q",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B00INVCHRC&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Convenience Kits International Men’s Premium 20-Piece Kit with Travel Size TSA Compliant Essentials, Featuring: Dove Men & Care Products in Black Dopp Bag",
    alt: "travel Mens Kit",
    url: "https://amzn.to/3w8X47z",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B00INVCHCC&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Convenience Kits International Women’s Premium 21-Piece Kit with Travel Size TSA Compliant Essentials, Featuring: L'Oreal Paris Hair Products in Stylish Cosmetic Bag",
    alt: "Womens convenience kit",
    url: "https://www.amazon.com/gp/product/B00INVCHCC/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00INVCHCC&linkCode=as2&tag=cabincrewesse-20&linkId=db1022a2b2c2724a147bacc0f1615b1a",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B07J3GSF7M&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Tsa Approved Travel Toiletry Bottles Containers Kit (LEAKPROOF BPA FREE) Travel Accessories - 12 Pieces/Clear Case",
    alt: "Travel Toiletry bottles Containers kit",
    url: "https://www.amazon.com/gp/product/B07J3GSF7M/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07J3GSF7M&linkCode=as2&tag=cabincrewesse-20&linkId=aa4b359340bebcca2c173a86ea40c874",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B07QXV6N1B&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Anker Portable Charger, PowerCore Slim 10000 Power Bank, 10000mAh Battery Pack, High-Speed PowerIQ Charging Technology for iPhone, Samsung Galaxy, and More",
    alt: "Power bank",
    url: "https://www.amazon.com/gp/product/B07QXV6N1B/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07QXV6N1B&linkCode=as2&tag=cabincrewesse-20&linkId=80a4c447fbf15ac7d5d157a644b0a0cb",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B07741S7Y8&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Kindle Paperwhite – Now Waterproof with 2x the Storage - 8 GB (International Version)",
    alt: "Kindle Paperwhite",
    url: "https://www.amazon.com/gp/product/B07741S7Y8/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07741S7Y8&linkCode=as2&tag=cabincrewesse-20&linkId=dd53b3c09948b0bdf4906624f6855f99",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B07SX3C2C5&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Portable Mini Refillable Perfume Atomizer Bottle，Atomizer Perfume Bottle,Refillable Perfume Spray, Scent Pump Case, Perfume Atomizer Refillable Travel 4 Pcs Pack of 5ml",
    alt: "Portable Atomizer",
    url: "https://www.amazon.com/gp/product/B07SX3C2C5/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07SX3C2C5&linkCode=as2&tag=cabincrewesse-20&linkId=e1577c323acd0350b258973fdbd48123",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B089CTZCTM&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "CHARMKING Copper Compression Socks (3 Pairs) 20-25 mmHg is Best Athletic for Women & Men, Running, Flight Travel, Support, Cycling, Gym - Boost Performance, Flexibility, Durability (S/M, Beige)",
    alt: "Compression Stockings",
    url: "https://www.amazon.com/gp/product/B089CTZCTM/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B089CTZCTM&linkCode=as2&tag=cabincrewesse-20&linkId=cb2a1ee804c780d71eb3fdc742860a99",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B00NR1YQHM&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Neutrogena Hydro Boost Hyaluronic Acid Hydrating Water Gel Daily Face Moisturizer for Dry Skin, Oil-Free, Non-Comedogenic & Dye-Free Face Lotion, 1.7 fl. oz",
    alt: "Neutrogena Moisterizer",
    url: "https://www.amazon.com/gp/product/B00NR1YQHM/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00NR1YQHM&linkCode=as2&tag=cabincrewesse-20&linkId=0c31cd9e0561241b26d06f3664d60417",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B00HVI8WYU&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "e.l.f., Hydrating Face Primer, Lightweight, Long Lasting, Creamy, Hydrates, Smooths, Fills in Pores and Fine Lines, Natural Matte Finish, Infused with Vitamin E, 0.47 Oz",
    alt: "Hydrating Mist",
    url: "https://www.amazon.com/gp/product/B00HVI8WYU/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00HVI8WYU&linkCode=as2&tag=cabincrewesse-20&linkId=4cc8855d6de98f5bd32164861a39e635",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B08JCNZX25&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Samply Hot Water Bottle- 2 Liter Water Bag with Knitted Cover,Transparent Purple",
    alt: "hot Water Bottle",
    url: "https://www.amazon.com/gp/product/B08JCNZX25/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B08JCNZX25&linkCode=as2&tag=cabincrewesse-20&linkId=b2f8b5007bdec542f79f7e21ca9ee231",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B07QV9M276&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "2 Pack: Womens Long Sleeve AOP Striped Pajama Sets Ladies Soft Winter Fall Sleepwear Pajamas Clothes Loungewear Long Sleeve Tops Pants Christmas Pj Sets for Women - Set 1 Medium",
    alt: "Pajama",
    url: "https://www.amazon.com/gp/product/B07QV9M276/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07QV9M276&linkCode=as2&tag=cabincrewesse-20&linkId=3a7cee1a645b38030d69ee686f2d815e",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B08GQFG4R9&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Seagate One Touch 2TB External Hard Drive HDD – Silver USB 3.0 for PC Laptop and Mac, 1 year MylioCreate, 4 Months Adobe Creative Cloud Photography Plan (STKB2000401)",
    alt: "Seagate 2TB",
    url: "https://www.amazon.com/gp/product/B08GQFG4R9/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B08GQFG4R9&linkCode=as2&tag=cabincrewesse-20&linkId=adb8059c94fbe82bab4b334957e11552",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B07L32B9C2&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Anker 4-Port USB 3.0 Hub, Ultra-Slim Data USB Hub with 2 ft Extended Cable [Charging Not Supported], for MacBook, Mac Pro, Mac mini, iMac, Surface Pro, XPS, PC, Flash Drive, Mobile HDD",
    alt: "Anker 4-port usb",
    url: "Anker 4-Port USB 3.0 Hub, Ultra-Slim Data USB Hub with 2 ft Extended Cable [Charging Not Supported], for MacBook, Mac Pro, Mac mini, iMac, Surface Pro, XPS, PC, Flash Drive, Mobile HDD",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B08ML2PW6W&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Dell XPS 13 (9310), 13.4- inch FHD+ Touch Laptop - Intel Core i7-1185G7, 16GB 4267MHz LPDDR4x RAM, 512GB SSD, Iris Xe Graphics, Windows 10 Pro - Platinum Silver with Black Palmrest (Latest Model)",
    alt: "Dell XPS 13",
    url: "https://www.amazon.com/gp/product/B08ML2PW6W/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B08ML2PW6W&linkCode=as2&tag=cabincrewesse-20&linkId=25411b5adf404885a4dc15b6bdeb8437",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B0756CYWWD&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Bose QuietComfort 35 II Wireless Bluetooth Headphones, Noise-Cancelling, with Alexa Voice Control - Black",
    alt: "Bose Headphones",
    url: "https://www.amazon.com/gp/product/B0756CYWWD/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B0756CYWWD&linkCode=as2&tag=cabincrewesse-20&linkId=9c1f9fc0c22936fbbd4992ddaa162ca5",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B07H95Z7H5&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "RFID Front Pocket Slim Wallets- Genuine Leather Handmade Minimalist Credit Card Holder By Clifton Heritage (Small, 01 Black Carbon)",
    alt: "Slim Card Wallet",
    url: "https://www.amazon.com/gp/product/B07H95Z7H5/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07H95Z7H5&linkCode=as2&tag=cabincrewesse-20&linkId=68d31278b2201c194758d914a529313c",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B01N1QAJL0&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Shiseido Twin Pack Senka Perfect Whip 120g x 2 (Japan Import))",
    alt: "Shiseido face wash",
    url: "https://www.amazon.com/gp/product/B01N1QAJL0/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01N1QAJL0&linkCode=as2&tag=cabincrewesse-20&linkId=ec1e30b1b9fdba28718ba2c04ac622b8",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B072MFZ2WV&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Staples Top Bound Memo Books, 3\" x 5\", 10/Pack (10 Pack)",
    alt: "notepad",
    url: "https://www.amazon.com/gp/product/B072MFZ2WV/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B072MFZ2WV&linkCode=as2&tag=cabincrewesse-20&linkId=f01ae1f4145c1b9a440a75ca7c29de25",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B07FY45C46&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Kao MEGURISM Health Care Steam Warm Eye Mask,Made in Japan,No fragrance 12 Sheets",
    alt: "sleep eye mask",
    url: "https://www.amazon.com/gp/product/B07FY45C46/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07FY45C46&linkCode=as2&tag=cabincrewesse-20&linkId=d03d8ca6d5040a0ed9580cab47aea0f8",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B089Y138TB&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Fujifilm Instax Mini 11 Instant Camera + Instax Mini Twin Pack Film + Hanging Frames + Plastic Frames + Case + Close Up Filters - All Inclusive Bundle! (Charcoal Grey)",
    alt: "sleep eye mask",
    url: "https://www.amazon.com/gp/product/B089Y138TB/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B089Y138TB&linkCode=as2&tag=cabincrewesse-20&linkId=bbe725772556a033dfd4a7cef3f1b947",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B01N4B7C9X&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "YAMIU Travel Shoe Bags Set of 4 Waterproof Nylon with Zipper for Men & Women, Black",
    alt: "Travel Shoe Bags",
    url: "https://www.amazon.com/gp/product/B01N4B7C9X/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B01N4B7C9X&linkCode=as2&tag=cabincrewesse-20&linkId=d7080ae69fd5baa42dde9039243ca817",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B08SL3S5Y2&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "7 Set Packing Cubes,Travel Luggage Organizers with Laundry Bag & Shoes Bag (blue)",
    alt: "Packing Cubess",
    url: "https://www.amazon.com/gp/product/B08SL3S5Y2/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B08SL3S5Y2&linkCode=as2&tag=cabincrewesse-20&linkId=0fd0c3d0faf432d69dde74e3e7d0dc8c",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B07K21C36X&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Drizzle Foldable Electric Hot Pot Cooker Dual Voltage100V-240V Mini Kettle Food Grade Silicone Cookerware Boiling Water Steamer Portable Travel",
    alt: "Hot Pot travel",
    url: "https://www.amazon.com/gp/product/B07K21C36X/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07K21C36X&linkCode=as2&tag=cabincrewesse-20&linkId=f66128f9a3c7f19e4613c14b550d6575",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B08QD47N45&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "Foldable Portable Kettle | Travel Kettle - Upgraded Food Grade Silicone, 5 Mins Heater To Quickly Foldable Electric Kettle, White 600ML 110V US Plug",
    alt: "Foldable Portable Kettle",
    url: "https://www.amazon.com/gp/product/B08QD47N45/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B08QD47N45&linkCode=as2&tag=cabincrewesse-20&linkId=495975e42b140cf96d41463e57e9a659",
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B07KGHMZ6W&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "WANDRD Travel Journal Notebook with World Maps, Itineraries, Trip Logs, and Vacation Planning Checklists (Yellow)",
    alt: "Travel Journal Notebook",
    url: "https://www.amazon.com/gp/product/B07KGHMZ6W/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07KGHMZ6W&linkCode=as2&tag=cabincrewesse-20&linkId=60f65547d4d9abc483f417554b1ae9c8"
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B07CWPL66T&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "3pcs/pack Sariok Clear Toiletry Bag with Zipper TSA Approved Travel Cosmetic Bag PVC Make-up Pouch Handle Straps for Women Men, Carry On Airport Airline Compliant Quart Bags 3-1-1 Kit Luggage",
    alt: "Toiletry bag",
    url: "https://www.amazon.com/gp/product/B07CWPL66T/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B07CWPL66T&linkCode=as2&tag=cabincrewesse-20&linkId=66b1630c0dda30cbc0e2f4c73b0d55d0"
  },
  {
    id: Math.random().toString(),
    img: "https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B073CXHFSW&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=cabincrewesse-20",
    name: "TSA Approved Fly Travel Toiletry Bag Makeup Pouch, ProCase Durable Quart-Size Carry-On Clear Small Handy Bag with Zipper for Liquids Bottles Tubes Cosmetics Container (2-Pack)",
    alt: "TSA Bag",
    url: "https://www.amazon.com/gp/product/B073CXHFSW/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B073CXHFSW&linkCode=as2&tag=cabincrewesse-20&linkId=85bc1c7106bf6ae438d0e829a6f6da0f"
  },




];



const ProductList = () => {
    const itemsamount = travelitems.length;


    //put banner alert on top of site

  return (
    <div className="wrapper">
        <p className="result-count">Showing all {itemsamount} results</p>

        <ul className="cards">
          {travelitems.map((item) => 


          <li className="card" key={item.id}>
            <a href={item.url} className="card__link">
            <div className="card__container">
            <img src={item.img} alt={item.alt} className="card__image"></img>
            </div>
            <div className="card__content">
              <p>{item.name.substring(0, 60) + '...'}</p>
            </div>
            </a>
            
            { console.log(item)}

          </li>

          
         

            

          )}
        </ul>


   
    </div>
  );
};

export default ProductList;


/*

<li className="productcard">
              <p>{props.name}</p>
              <a href={props.url}>
                <img className="productimg" src={props.url} alt={props.alt} />
              </a>
              <a href={props.url}>{props.name}</a>
            </li>;

*/